import { useEffect, useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import {
  cnfPwdValidation,
  isConatainsSymbol,
  passCharValidation,
  passLimitValidation,
  SessionKeys,
} from "../../utils/AppUtils";
import Loader from "../Loader/Loader";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import {
  changePasswordReq,
  changePasswordResClear,
} from "../../redux/user/actions";
import { useNavigate } from "react-router-dom";
import { getActiveHeader } from "../../redux/home/actions";
import { useTranslation } from "react-i18next";
const ChangePasswordSection = () => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const { t } = useTranslation();
  useEffect(() => {
    dispatch(getActiveHeader(""));
  }, []);

  const changePassRes = useSelector((state) => state.user.changePassRes);
  const userRole = useSelector((state) => state.user.role);

  const [isLoading, setIsLoading] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [cnfPassword, setCnfPassword] = useState("");
  const [htmlFormError, setFormError] = useState("");
  const [htmlFormSuccess, setFormSuccess] = useState("");
  const [confirmModal, setConfirmModal] = useState(false);
  const [showModalMsg, setShowModalMsg] = useState("");
  const [errorModal, setErrorModal] = useState(false);
  const [errorModalMsg, setErrorModalMsg] = useState("");

  const [isPassLength, setIsPassLength] = useState(false);
  const [isSymbol, setIsSymbol] = useState(false);
  const [matchPassword, setMatchPassword] = useState(false);

  const resetPassword = () => {
    // setFormError("");
    if (localStorage.getItem(SessionKeys.COACH_LOGIN) !== "true") {
      if (_.isEmpty(oldPassword)) {
        setFormError(t("please_enter_your_current_password"));
      }
    }
    if (!isPassLength || !isSymbol || !matchPassword) {
      return;
    } else {
      //   if (!passLimitValidation(password)) {
      //     setFormError("Please enter at least 6 characters.");
      //   } else if (!passLimitValidation(cnfPassword)) {
      //     setFormError("Please enter at least 6 characters.");
      //   } else if (!passCharValidation(password)) {
      //     setFormError(
      //       <>
      //         <ul className="setup-password-error">
      //           <li>Password must contain at least one uppercase letter</li>
      //           <li>Password must contain at least one lowercase letter</li>
      //           <li>Password must contain at least one number</li>
      //           <li>
      //             Password must contain at least one special character like
      //             !@#$%^&*
      //           </li>
      //         </ul>
      //       </>
      //     );
      //   } else if (!passCharValidation(cnfPassword)) {
      //     setFormError(
      //       <>
      //         <ul className="setup-password-error">
      //           <li>Password must contain at least one uppercase letter</li>
      //           <li>Password must contain at least one lowercase letter</li>
      //           <li>Password must contain at least one number</li>
      //           <li>
      //             Password must contain at least one special character like
      //             !@#$%^&*
      //           </li>
      //         </ul>
      //       </>
      //     );
      //   } else
      if (cnfPwdValidation(password, cnfPassword)) {
        setIsLoading(true);
        window.scrollTo(0, 100);
        let reqBody = {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          new_password: cnfPassword,
        };

        reqBody.current_password =
          localStorage.getItem(SessionKeys.COACH_LOGIN) !== "true"
            ? oldPassword
            : "";

        dispatch(
          changePasswordReq({
            module: "changePassword",
            postData: reqBody,
          }),
        );
      } else {
        // alert("Passwords do not match.")
        setFormError(
          t(
            "Passwords do not match. Please enter the same password in both fields.",
          ),
        );
      }
    }
  };

  useEffect(() => {
    if (htmlFormError) {
      setTimeout(() => {
        setFormError("");
      }, 10000);
    }
  }, [htmlFormError]);

  useEffect(() => {
    console.log("changePassRes: ", changePassRes);
    if (!_.isEmpty(changePassRes)) {
      setIsLoading(false);
      if (changePassRes?.status === "success") {
        setOldPassword("");
        setPassword("");
        setCnfPassword("");
        setIsPassLength(false);
        setIsSymbol(false);
        setFormSuccess(changePassRes?.payload?.message);
        setTimeout(() => {
          navigate(userRole === "provider" ? "/profile/detail" : "/home");
        }, 5000);
        // setShowModalMsg(changePassRes?.payload?.message);
        // setConfirmModal(true);
      } else {
        setFormError(changePassRes?.error?.message);
        // setErrorModalMsg(changePassRes?.error?.message);
        // setErrorModal(true);
      }

      dispatch(changePasswordResClear());
    }
  }, [changePassRes]);

  const renderAlertCard = () => {
    return (
      <div
        style={{ top: "-65px" }}
        className={`alert-card d-flex justify-content-center ${
          confirmModal ? "" : "d-none"
        }`}
      >
        <div className="shop-cart">
          <div className="shop-info justify-content-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
            >
              <g
                id="Group_5699"
                data-name="Group 5699"
                transform="translate(0.498 0.498)"
              >
                <circle
                  id="Ellipse_222"
                  data-name="Ellipse 222"
                  cx="9"
                  cy="9"
                  r="9"
                  transform="translate(-0.498 -0.498)"
                  fill="#A9C23C"
                />
                <path
                  id="Icon_material-done"
                  data-name="Icon material-done"
                  d="M9.712,16.558,7.79,14.88l-.9.9L9.712,18.35l6.425-6.657-.9-.9Z"
                  transform="translate(-3.013 -6.071)"
                  fill="#fff"
                  stroke="#fff"
                  strokeWidth="2"
                />
              </g>
            </svg>
            <p className="m-0">{showModalMsg}</p>
          </div>
          <div className="view-cart-icon">
            <i
              className="fa fa-times cursor-pointer"
              aria-hidden="true"
              onClick={() => {
                setConfirmModal(false);
                setShowModalMsg("");
              }}
            ></i>
          </div>
        </div>
      </div>
    );
  };

  const renderErrorAlertCard = () => {
    return (
      <div
        className={`alert-card d-flex justify-content-center ${
          errorModal ? "" : "d-none"
        }`}
      >
        <div className="shop-cart">
          <div className="shop-info justify-content-center">
            {/* <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                                <g id="Group_5699" data-name="Group 5699" transform="translate(0.498 0.498)">
                                    <circle id="Ellipse_222" data-name="Ellipse 222" cx="9" cy="9" r="9" transform="translate(-0.498 -0.498)" fill="#A9C23C" />
                                    <path id="Icon_material-done" data-name="Icon material-done" d="M9.712,16.558,7.79,14.88l-.9.9L9.712,18.35l6.425-6.657-.9-.9Z" transform="translate(-3.013 -6.071)" fill="#fff" stroke="#fff" strokeWidth="2" />
                                </g>
                            </svg> */}
            <p className="m-0">{errorModalMsg}</p>
          </div>
          <div className="view-cart-icon">
            <i
              className="fa fa-times cursor-pointer"
              aria-hidden="true"
              onClick={() => {
                setErrorModal(false);
                setErrorModalMsg("");
              }}
            ></i>
          </div>
        </div>
      </div>
    );
  };

  const myFunction = () => {
    var x = document.getElementById("passInput");
    var y = document.getElementById("eyeImg");
    if (x.type === "password") {
      x.type = "text";
      y.src = "/images/finwell-img/view.png";
    } else {
      x.type = "password";
      y.src = "/images/finwell-img/private.png";
    }
  };

  const myFunction1 = () => {
    var x = document.getElementById("newPassInput");
    var y = document.getElementById("eyeImg1");
    if (x.type === "password") {
      x.type = "text";
      y.src = "/images/finwell-img/view.png";
    } else {
      x.type = "password";
      y.src = "/images/finwell-img/private.png";
    }
  };

  const myFunction2 = () => {
    var x = document.getElementById("newConfirmPassInput");
    var y = document.getElementById("eyeImg2");
    if (x.type === "password") {
      x.type = "text";
      y.src = "/images/finwell-img/view.png";
    } else {
      x.type = "password";
      y.src = "/images/finwell-img/private.png";
    }
  };

  useEffect(() => {
    if (password && cnfPassword) {
      if (password === cnfPassword) {
        setMatchPassword(true);
      } else {
        setMatchPassword(false);
      }
    } else {
      setMatchPassword(false);
    }
  }, [password, cnfPassword]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Loader start={isLoading} />
      <div className="page-wrapper-rsp">
        <section className="setup-password">
          <div className="container position-relative">
            {renderAlertCard()}
            {renderErrorAlertCard()}
            <div className="row">
              <div
                className={`col-8 col-sm-7 col-md-5 col-xl-4 col-lg-4 right-space`}
              >
                <div className="heading ">
                  <h3 className="requesthead mb-3">
                    {t("change_your_password")}
                  </h3>

                  <form
                    onSubmit={(event) => {
                      event.preventDefault();

                      resetPassword();
                    }}
                  >
                    {localStorage.getItem(SessionKeys.COACH_LOGIN) ===
                    "true" ? (
                      ""
                    ) : (
                      <div className="input-text">
                        <label htmlFor="password" className="input__label">
                          {t("enter_current_password")}
                        </label>
                        <div className="position-relative">
                          <input
                            id="passInput"
                            type="password"
                            className="input__field"
                            placeholder={t("enter_password")}
                            aria-label="password"
                            aria-describedby="basic-addon1"
                            value={oldPassword}
                            onChange={(e) => setOldPassword(e.target.value)}
                          />
                          <div
                            className="show-pass"
                            onClick={() => {
                              myFunction();
                            }}
                          >
                            <img
                              id="eyeImg"
                              src="/images/finwell-img/private.png"
                              alt="view"
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="input-text">
                      <label htmlFor="password" className="input__label">
                        {t("enter_new_password")}
                      </label>
                      <div className="position-relative">
                        <input
                          id="newPassInput"
                          type="password"
                          className="input__field"
                          placeholder={t("enter_password")}
                          aria-label="password"
                          aria-describedby="basic-addon1"
                          value={password}
                          onChange={(e) => {
                            console.log("onChange: ", e.target.value);
                            if (
                              !(
                                _.isEmpty(e.target.value) ||
                                e.target.value?.length < 8
                              )
                            )
                              setIsPassLength(true);
                            else setIsPassLength(false);

                            if (
                              !_.isEmpty(e.target.value) &&
                              isConatainsSymbol(e.target.value)
                            )
                              setIsSymbol(true);
                            else setIsSymbol(false);

                            setPassword(e.target.value);
                          }}
                        />
                        <div
                          className="show-pass"
                          onClick={() => {
                            myFunction1();
                          }}
                        >
                          <img
                            id="eyeImg1"
                            src="/images/finwell-img/private.png"
                            alt="view"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="input-text">
                      <label
                        htmlFor="confirm_password"
                        className="input__label"
                      >
                        {t("confirm_new_password")}
                      </label>
                      <div className="position-relative">
                        <input
                          id="newConfirmPassInput"
                          type="password"
                          className="input__field"
                          placeholder={t("confirm_password")}
                          aria-label="password"
                          aria-describedby="basic-addon1"
                          value={cnfPassword}
                          onChange={(e) => setCnfPassword(e.target.value)}
                        />
                        <div
                          className="show-pass"
                          onClick={() => {
                            myFunction2();
                          }}
                        >
                          <img
                            id="eyeImg2"
                            src="/images/finwell-img/private.png"
                            alt="view"
                          />
                        </div>
                      </div>
                    </div>
                    <div className={"validation-pass mb-3"}>
                      <div
                        className={`valid-text ${isPassLength ? "active" : ""}`}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <rect
                            width="20"
                            height="20"
                            rx="10"
                            fill={"#D1D1D1"}
                          />
                          <path
                            d="M6.25 10L8.75 12.5L13.75 7.5"
                            stroke="white"
                            strokeWidth="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        {t("must_be_at_least_8_characters")}
                      </div>
                      <div className={`valid-text ${isSymbol ? "active" : ""}`}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <rect
                            width="20"
                            height="20"
                            rx="10"
                            fill={"#D1D1D1"}
                          />
                          <path
                            d="M6.25 10L8.75 12.5L13.75 7.5"
                            stroke="white"
                            strokeWidth="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        {t("must_contain_one_special_character")}
                      </div>
                      <div
                        className={`valid-text ${
                          matchPassword ? "active" : ""
                        }`}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <rect
                            width="20"
                            height="20"
                            rx="10"
                            fill={"#D1D1D1"}
                          />
                          <path
                            d="M6.25 10L8.75 12.5L13.75 7.5"
                            stroke="white"
                            strokeWidth="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        {t("must_match_confirm_new_password")}
                      </div>
                    </div>

                    <div className="save_button mt-3">
                      {isLoading ? (
                        <button className="session-btn w-100 m-0">
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        </button>
                      ) : (
                        <button type="submit" className="session-btn w-100 m-0">
                          {t("reset")}
                        </button>
                      )}
                      <div className="mb-2 login-msg">
                        {htmlFormError && (
                          <div className="mt-2" style={{ color: "red" }}>
                            {htmlFormError}
                          </div>
                        )}
                        {htmlFormSuccess && (
                          <div className="mt-2" style={{ color: "green" }}>
                            {htmlFormSuccess}
                          </div>
                        )}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
export default ChangePasswordSection;
